import React from 'react';
import DenyCaseDocument from "./DenyCaseDocument";
import AddDocumentToCase from "./addDocumnetToCase";
import AdditionalFileRequest from "./additionalFileRequest";
import PostPoneCaseDocument from "./postPoneCaseDocument";
import DeclineExtentionFile from "./declineExtentionFile";
import ConditionalDeadlineDocument from "./conditionalDeadlineDocument";
import InternalUserRequestDocument from "./internalUserRequestDocument";
import SplitButton from './SplitButton';
import OrderDecisionEnum from "../../../enums/orderDecisionEnum";

const DocumentPopup = ({
                           documentTypes,
                           refreshCaseFiles,
                           selectedDocuments,
                           isDenyButtonDisabled,
                           declinationDocExist,
                           isDenyButtonDisabledDetail,
                           isDenyButtonDisabledGeo,
                           caseGeography,
                           documentTypesForEditor,
                           clearSelectedDocuments,
                           userProlongationDays,
                           currentUserId,
                           isDenyButtonDisabledParentId,
                           permitTypeId,
                           disableAdditionalFileRequest,
                           disablePostponeDocCreation,
                           declineDaysExtension,
                           caseFiles,
                           extendFileExists,
                           caseData,
                           isConditionButtonDisabled,
                           hasConditionalDeadline,
                           refreshFlow,
                           userId,
                           users,
                           roleId,
                           barcode,
                           departments,
                           hasExtention,
                           holidays,
                           objectOwner,
                           caseInfo,
                           hasOrderDate,
                           orderDepartment,
                           declineRequestStatus,
                           permitTypeTitle,
                           ownerIdentificationTemplateString,
                           exploitationIdentificationTemplateString,
                           isAddressRejected,
                           isCadastralCodeRejected,
                           declinedDetails,
                           address,
                           cadastralCodeArray,
                           userAddress

                       }) => {
    const approveDocExists = caseFiles.filter(doc => doc.orderDecision === OrderDecisionEnum.Approve.id)

    const renderDocumentComponent = (doc) => {
        switch (doc.documentTypeStatus) {
            case 3:
                return (
                    <DenyCaseDocument
                        isAddressRejected={isAddressRejected}
                        onFileAdded={refreshCaseFiles}
                        selectedDocuments={selectedDocuments}
                        isDisabled={!isDenyButtonDisabled}
                        hasDisabledTextField={(!isDenyButtonDisabledDetail || !isDenyButtonDisabledGeo || isDenyButtonDisabledParentId)}
                        caseGeography={caseGeography}
                        documentTypes={documentTypesForEditor}
                        currentUserId={currentUserId}
                        removeCheckboxes={clearSelectedDocuments}
                        docType={doc}
                        buttonTitle={doc.name}
                        userId={userId}
                        barcode={barcode}
                        caseInfo={caseInfo}
                        users={users}
                        objectOwner={objectOwner}
                        permitTypeTitle={permitTypeTitle}
                        ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                        exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                        isCadastralCodeRejected={isCadastralCodeRejected}
                        declinedDetails={declinedDetails}
                        address={address}
                        cadastralCodeArray={cadastralCodeArray}
                        userAddress={userAddress}

                    />
                );
            case 1:
                return (
                    <AddDocumentToCase
                        onFileAdded={refreshCaseFiles}
                        documentTypes={documentTypesForEditor}
                        permitTypeId={permitTypeId}
                        docType={doc}
                        buttonTitle={doc.name}
                        userId={userId}
                        barcode={barcode}
                        caseData={caseData}
                        disabledBecauseOfDeclinedFiles={declinationDocExist}
                        caseInfo={caseInfo}
                        users={users}
                        objectOwner={objectOwner}
                        hasOrderDate={hasOrderDate}
                        orderDepartment={orderDepartment}
                        permitTypeTitle={permitTypeTitle}
                        ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                        exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                        userAddress={userAddress}

                    />
                );
            case 2:
                return (
                    roleId !== "HEADOFAGENCY" && roleId !== "DEPUTYHEADOFAGENCY" && (
                        <InternalUserRequestDocument
                            onFileAdded={refreshCaseFiles}
                            documentTypes={documentTypesForEditor}
                            permitTypeId={permitTypeId}
                            caseFiles={caseFiles}
                            users={users}
                            userId={userId}
                            roleId={roleId}
                            onFlowChange={refreshFlow}
                            docType={doc}
                            objectOwner={objectOwner}
                            buttonTitle={doc.name}
                            barcode={barcode}
                            departments={departments}
                            caseInfo={caseInfo}
                            permitTypeTitle={permitTypeTitle}
                            ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                            exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                            userAddress={userAddress}
                        />
                    )

                );
            case 6:
                return (
                    <AdditionalFileRequest
                        onFileAdded={refreshCaseFiles}
                        Disabled={disableAdditionalFileRequest}
                        documentTypes={documentTypesForEditor}
                        docType={doc}
                        users={users}
                        objectOwner={objectOwner}
                        buttonTitle={doc.name}
                        userId={userId}
                        barcode={barcode}
                        caseInfo={caseInfo}
                        permitTypeTitle={permitTypeTitle}
                        ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                        exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                        userAddress={userAddress}
                    />
                );
            case 4:
                return (
                    hasExtention &&
                    (
                        <PostPoneCaseDocument
                            onFileAdded={refreshCaseFiles}
                            Disabled={disablePostponeDocCreation}
                            documentTypes={documentTypesForEditor}
                            docType={doc}
                            objectOwner={objectOwner}
                            buttonTitle={doc.name}
                            userId={userId}
                            barcode={barcode}
                            caseFiles={caseFiles}
                            holidays={holidays}
                            caseInfo={caseInfo}
                            users={users}
                            permitTypeTitle={permitTypeTitle}
                            ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                            exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                            userAddress={userAddress}
                        />
                    )

                );
            case 16:
                return (
                    declineRequestStatus &&
                    (
                        <AddDocumentToCase
                            onFileAdded={refreshCaseFiles}
                            documentTypes={documentTypesForEditor}
                            permitTypeId={permitTypeId}
                            docType={doc}
                            buttonTitle={doc.name}
                            userId={userId}
                            barcode={barcode}
                            orderDepartment={orderDepartment}
                            caseData={caseData}
                            caseInfo={caseInfo}
                            users={users}
                            objectOwner={objectOwner}
                            isFileCancelRequestBuilding={true}
                            permitTypeTitle={permitTypeTitle}
                            ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                            exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                            userAddress={userAddress}
                        />
                    )

                );
            case 10:
                return (
                    declineDaysExtension && (
                        <DeclineExtentionFile
                            onFileAdded={refreshCaseFiles}
                            userProlongationDays={userProlongationDays}
                            caseFiles={caseFiles}
                            disableButton={extendFileExists}
                            documentTypes={documentTypesForEditor}
                            userId={userId}
                            barcode={barcode}
                            objectOwner={objectOwner}
                            orderDepartment={orderDepartment}
                            caseInfo={caseInfo}
                            users={users}
                            docType={doc}
                            permitTypeTitle={permitTypeTitle}
                            ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                            exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                            userAddress={userAddress}
                        />
                    )
                );
            case 11:
                return (
                    hasExtention &&
                    (
                        <AddDocumentToCase
                            onFileAdded={refreshCaseFiles}
                            documentTypes={documentTypesForEditor}
                            permitTypeId={permitTypeId}
                            docType={doc}
                            orderDepartment={orderDepartment}
                            buttonTitle={doc.name}
                            userId={userId}
                            barcode={barcode}
                            caseData={caseData}
                            objectOwner={objectOwner}
                            isExtentionAttachment={true}
                            caseInfo={caseInfo}
                            users={users}
                            hasOrderDate={hasOrderDate}
                            permitTypeTitle={permitTypeTitle}
                            ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                            exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                            userAddress={userAddress}
                        />
                    )
                );
            case 17:
                return (
                    (
                        <AddDocumentToCase
                            onFileAdded={refreshCaseFiles}
                            documentTypes={documentTypesForEditor}
                            permitTypeId={permitTypeId}
                            docType={doc}
                            objectOwner={objectOwner}
                            buttonTitle={doc.name}
                            orderDepartment={orderDepartment}
                            userId={userId}
                            barcode={barcode}
                            caseData={caseData}
                            caseInfo={caseInfo}
                            users={users}
                            orderExists={approveDocExists.length === 0}
                            hasOrderDate={hasOrderDate}
                            permitTypeTitle={permitTypeTitle}
                            ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                            exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                            userAddress={userAddress}
                        />
                    )
                );
            case 12:
                return (
                    hasExtention &&
                    (
                        <AddDocumentToCase
                            onFileAdded={refreshCaseFiles}
                            documentTypes={documentTypesForEditor}
                            permitTypeId={permitTypeId}
                            docType={doc}
                            orderDepartment={orderDepartment}
                            buttonTitle={doc.name}
                            userId={userId}
                            objectOwner={objectOwner}
                            barcode={barcode}
                            caseData={caseData}
                            isExtentionAttachment={true}
                            caseInfo={caseInfo}
                            users={users}
                            hasOrderDate={hasOrderDate}
                            permitTypeTitle={permitTypeTitle}
                            ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                            exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                            userAddress={userAddress}
                        />
                    )
                )
            case 5:
                return (
                    hasConditionalDeadline && (
                        <ConditionalDeadlineDocument
                            onFileAdded={refreshCaseFiles}
                            selectedDocuments={selectedDocuments}
                            isDisabled={!isConditionButtonDisabled}
                            caseGeography={caseGeography}
                            documentTypes={documentTypesForEditor}
                            currentUserId={currentUserId}
                            removeCheckboxes={clearSelectedDocuments}
                            declinationDocExist={declinationDocExist}
                            docType={doc}
                            buttonTitle={doc.name}
                            userId={userId}
                            objectOwner={objectOwner}
                            barcode={barcode}
                            caseInfo={caseInfo}
                            users={users}
                            permitTypeTitle={permitTypeTitle}
                            ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                            exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                            userAddress={userAddress}
                        />
                    )
                );
            default:
                return null;
        }
    };

    return (
        <div style={{marginRight: 9}}>
            <SplitButton
                options={documentTypes}
                renderDocumentComponent={renderDocumentComponent}
                buttonLabel="დოკუმენტის შექმნა"
            />
        </div>
    );
};

export default DocumentPopup;
